module.exports = __webpack_public_path__ + "img/device.14716831.png";